import { Component, OnInit } from '@angular/core';

import { SpecificComponent } from '../specific.component';
import { BackAuthEntitySearchResult } from 'src/app/_common/models/search-result';

@Component({
    selector: 'aa-search-result-back-auth-entity',
    templateUrl: './back-auth-entity.component.html',
    styleUrls: [
        '../specific-shared.scss',
        '../../../../../../admin/entities/columns-shared.scss'
    ],
    standalone: false
})
export class BackAuthEntityComponent extends SpecificComponent<BackAuthEntitySearchResult> implements OnInit
{
    constructor()
    {
        super();
    }

    ngOnInit ()
    {
    }
}
